import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirmalert" }
const _hoisted_2 = { class: "confirmalert-window" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { href: "https://mmr-claim.vercel.app/" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "submit" }, "Claim")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.message), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.submessage), 1),
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.no!())),
          class: "cancel"
        }, "No Thanks")
      ])
    ])
  ]))
}